// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"808":"ebe473e0","856":"52bf2ac4","952":"83c7089c"}[chunkId] + ".chunk.js";
};